import { render, staticRenderFns } from "./CoverageItem.vue?vue&type=template&id=7f344eea&scoped=true"
import script from "./CoverageItem.vue?vue&type=script&lang=js"
export * from "./CoverageItem.vue?vue&type=script&lang=js"
import style0 from "./CoverageItem.vue?vue&type=style&index=0&id=7f344eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f344eea",
  null
  
)

export default component.exports